import React, { useState, useEffect, useRef, } from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import axios from 'axios';
import { FaSave, FaUserCircle } from 'react-icons/fa';
import './Dasbord.css'
import { Api } from '../services/api';
import { InputText } from 'primereact/inputtext';
import ProductionSetting from './Setting/Production Setting/ProductionSetting';
import { VscGear } from 'react-icons/vsc';

import { MdKeyboardDoubleArrowRight } from "react-icons/md";
import { MdKeyboardDoubleArrowLeft } from "react-icons/md";


const DashbordArchived = ({ typeOfData }) => {
  const [projects, setProjects] = useState([]);
  const [expandedRows, setExpandedRows] = useState([]);
  const [monthList, setMonthList] = useState([]);
  const [totalEstiMated, setTotalEstiMated] = useState(0);
  const [isLoading, setIsLoading] = useState(true);
  const [selectOnStartDate, setSelectOnStartDate] = useState('2023-01-01')
  const [selectOnEndDate, setSelectOnEndDate] = useState('2025-12-31')
  const [isModalOpen, setIsModalOpen] = useState(false);

  const [showFsaColumns, setShowFsaColumns] = useState(false);

  const [selectedProject, setSelectedProject] = useState(null);

  const toast = useRef(null);

  useEffect(() => {
    getDashboardData();
  }, [typeOfData]);

  // *-----------------
  const openEditModal = () => {
    setIsModalOpen(true);
  }

  const closeModelAdd = (w) => {
    setIsModalOpen(false);
  }
  // !-----------------

  const getDashboardData = () => {
    setIsLoading(true);
    const token = localStorage.getItem('authToken');

    const headers = {
      'Content-Type': 'application/json',
      'Authorization': token ? `Bearer ${token}` : '',
      'Cache-Control': 'no-cache'
    };

    console.log('typeOfData--', typeOfData)
    var url = Api.API_BASE_URL + 'get-production-schedule';
    if (typeOfData == 'completed') {
      url = Api.API_BASE_URL + 'completed-jobs';
    }
    if (typeOfData == 'archived') {
      url = Api.API_BASE_URL + 'project-archive';
    }
    axios.get(url, { headers })
      .then((response) => {
        setProjects(response.data.result)
        setIsLoading(false);
        setMonthList(response.data.monthList);


        if (response.data.setting) {
          if (response.data.setting.startDate != null) {
            let timestamp = new Date(response.data.setting.startDate);



            if (!isNaN(timestamp.getTime())) {
              var formData = timestamp.toISOString().split('T')[0];
              setSelectOnStartDate(formData)
            }
          }
          if (response.data.setting.endDate != null) {
            let timestamp = new Date(response.data.setting.endDate);



            if (!isNaN(timestamp.getTime())) {
              var formData = timestamp.toISOString().split('T')[0];
              setSelectOnEndDate(formData)
            }
          }
        }

        let total = 0;
        response.data.result.forEach(element => {
          if (element.esitmatedSales !== 0 && element.esitmatedSales !== '' && element.esitmatedSales !== null) {
            total += parseInt(element.esitmatedSales);
          }
        });
        setTotalEstiMated(total);

        var dea = [];
        response.data.result.forEach(element => {
          const isNameExist = dea.some(item => item.projectType === element.projectType);
          if (isNameExist) {
            console.log('exist');
          } else {
            dea.push(element);
          }
        })
        setExpandedRows(dea);
      })


      .catch((error) => {
        console.error('Error fetching projects:', error);
        setIsLoading(false);
      });
  }

  const showDate = (date) => {
    if (date == '0000-00-00') {
      return '';
    }
    if (date == '0/0') {
      return '';
    }
    if (date == null) {
      return ''
    }

    let timestamp = new Date(date);

    if (!isNaN(timestamp.getTime())) {
      date = timestamp.toISOString().split('T')[0];
    }
    return date;
  }

  function checkDateForMonthe(givenDate, monthColor) {

    if (givenDate == '0000-00-00') {
      return '';
    }
    if (givenDate == '0/0') {
      return '';
    } if (givenDate == null || givenDate == 'null') {
      return '';
    }

    const currentDate = new Date();
    const dateToCheck = new Date(givenDate);
    if (monthColor == 'Y') {
      return <span style={{ color: 'green' }}>{givenDate}</span>;
    }

    if (dateToCheck < currentDate) {
      return <span style={{ color: 'red' }}>{givenDate}</span>;
    }

    return givenDate;
  }

  const showDevide = (date, projectType = '') => {
    if (projectType === 'y Workload by Job/Hours' || projectType === 'x Workload by Job' || projectType === 'z Workload by Hours') {
      return '';
    }
    if (date === '' || date === null) {
      return '0/0';
    }
    return date;
  }

  const getColorForDate = (date) => {
    const [day, month] = date.split('/').map(Number);
    return day > 0 || month > 0 ? 'red' : '#00D26A';
  }

  const balanceTemplate = (rowData) => {
    if (rowData == null) {

    }
    if (rowData === '') {
      return '';
    }
    if (typeof rowData == 'string') {
      rowData = parseInt(rowData);
    }
    if (rowData == 0) {
      return '';
    }
    return <span className="font-bold">{formatCurrency(rowData)}</span>;
  };

  const formatCurrency = (value) => {
    if (value == null) {
      return ''
    }
    return value.toLocaleString('en-US', { style: 'currency', currency: 'USD' });
  };

  const getPMNameAndIcon = (projectType, projectTypeColorCode) => {
    return <span><FaUserCircle style={{ color: "#" + projectTypeColorCode }} /> {projectType}</span>
  }

  const StartDateAndEndDateSelect = () => {

    const startDate = new Date(selectOnStartDate);
    const endDate = new Date(selectOnEndDate);

    if (startDate > endDate) {
      toast.current.show({ severity: 'error', summary: 'Error', detail: 'Start date should be before end date.' });
      return;
    }

    updateDateInBackend(selectOnStartDate, selectOnEndDate);

    localStorage.setItem('startYear', selectOnStartDate);
    localStorage.setItem('endYear', selectOnEndDate);
  }

  const updateDateInBackend = (startDate, endDate) => {
    setIsLoading(true);
    var _body = {
      startDate: startDate,
      endDate: endDate
    }
    const token = localStorage.getItem('authToken');

    // Create headers with token if it exists
    const headers = {
      'Content-Type': 'application/json',
      'Authorization': token ? `Bearer ${token}` : ''
    };
    fetch(Api.API_BASE_URL + 'change-startDate-endDate/1', {
      method: "POST",
      headers: headers,
      body: JSON.stringify(_body),
    })
      .then((response) => response.json())
      .then((response) => {
        setIsLoading(false);
        getDashboardData();
      })
      .catch((error) => {
        setIsLoading(false);
        console.error("Error:", error);
      });
  }


  // *-------------------------
  const toggleFsaColumns = () => {
    setShowFsaColumns(!showFsaColumns);
  };
  // !-------------------------

  const header = (
    <div className="flex  justify-content-between items-center p-2 gap-8" >

      <div className="flex">
        <span className="" style={{ padding: '5px 10px 5px 5px' }}>
          <span style={{ fontStyle: 'italic', fontSize: 14, marginRight: 5, color: 'gray' }}>TOTAL ESTIMATED SALES:</span>{" "}
          <strong>{balanceTemplate(totalEstiMated)}</strong>
        </span>

      </div>

      <div className='flex gap-4 items-center' style={{ alignItems: 'center' }} >
        <div>
          <label style={{ fontWeight: '400', marginRight: '5px' }}>Start Date</label>
          <InputText type="date" style={{ height: '40px', borderRadius: '8px', border: '1px solid #80808B', padding: '10px' }} value={selectOnStartDate} onChange={(e) => setSelectOnStartDate(e.target.value)} />

        </div>
        <div>
          <label style={{ fontWeight: '400', marginRight: '5px' }}>End Date</label>
          <InputText type="date" style={{ height: '40px', borderRadius: '8px', border: '1px solid #80808B', padding: '10px' }} value={selectOnEndDate} onChange={(e) => setSelectOnEndDate(e.target.value)} />

        </div>

        <div>
          <button type="button" title='Save the Date' style={{ cursor: 'pointer' }} onClick={StartDateAndEndDateSelect} className="customSave-button m-2" >
            <div className='flex items-center gap-2 px-1 ' style={{ alignItems: 'center' }}>
              <FaSave size={16} />
              <span> SAVE </span>
            </div>
          </button>
        </div>


        <div className='mr-4 flex items-center ' style={{ cursor: 'pointer' }}>
          <VscGear size={22} fill='black' title='Change the Pm Capacity' onClick={() => openEditModal()} />
        </div>

      </div>



    </div>
  );

  const rowClass = (data) => {
    return {
      'bg-gray-200': data.pM === 'Total Jobs' || data.pM === 'PM Available' || data.pM === 'PM Capacity' || data.pM === 'PM +/-'
    };
  };

  const hoursPerDay = (projectType, hour_per) => {
    if (projectType === 'y Workload by Job/Hours' || projectType === 'x Workload by Job' || projectType === 'z Workload by Hours') {
      return ''
    }
    return hour_per;
  }

  function getFutureDate(dateString, monthsToAdd) {
    if (dateString == null) {
      return null;
    }

    const completionDate = dateString instanceof Date ? dateString : new Date(dateString);
    if (isNaN(completionDate)) {
      return null;
    }

    const futureDate = new Date(completionDate.setMonth(completionDate.getMonth() + monthsToAdd));
    return futureDate.toISOString().split('T')[0];
  }




  return (
    <>

      <div className="p-2" style={{ paddingTop: '0', height: '90vh' }}>
        <div className="fd" >

          {isLoading ? (
            <div className="loading-spinner">
              Loading...
              <div className="spinner"></div>
            </div>
          ) : (
            <div>
              <div className="dataTableContainer">
                <DataTable
                  value={projects}
                  rowClassName={rowClass}

                  selectionMode="single"
                  selection={selectedProject}
                  onSelectionChange={(e) => setSelectedProject(e.value)}


                  size="small"
                  showGridlines
                  sortMode="single"
                  sortOrder={1}
                  scrollable
                  scrollHeight="flex"

                  header={header}
                  className='p-frozen-column'
                  tableStyle={{ minWidth: '100px', tableLayout: 'fixed', width: 'auto', borderCollapse: 'separate', borderSpacing: '0', }}
                >

                  <Column field="projectName" header="Project Name" frozen style={{ minWidth: '300px', textAlign: 'left', marginLeft: '2px', }} body={(rowData) => (<>{rowData.projectName} {rowData.internal_job === 'Y' ? '✅' : ''}</>)} />

                  <Column field="esitmatedSales" header="Estimated Sales" body={(e) => balanceTemplate(e.esitmatedSales)} frozen="left" style={{ minWidth: '100px', textAlign: 'center', borderRight: '1px solid black' }} />

                  <Column
                    field="contactDate"
                    body={(e) => showDate(e.contactDate)}
                    style={{ minWidth: '130px', textAlign: 'center' }}
                    header={
                      <div className="flex justify-content-between align-items-center">
                        <span>Contact Date</span>
                        <button className='' onClick={toggleFsaColumns}>
                          {showFsaColumns ? <MdKeyboardDoubleArrowLeft size={18} /> : <MdKeyboardDoubleArrowRight size={18} />}
                        </button>
                      </div>
                    }
                  />



                  {/* //*--------------------------New Added 14 0602024------------------------------------------------- */}
                  {showFsaColumns && (
                    <Column field="contact_to_fsa_development" header="Contact to FSA Development" body={(e) => showDate(e.contact_to_fsa_development)} style={{ minWidth: '120px', textAlign: 'center' }} headerStyle={{ background: "#99FFFF" }} />
                  )}

                  {showFsaColumns && (
                    <Column field="development_date" header="FSA Development DATE" body={(e) => showDate(e.development_date)} style={{ minWidth: '120px', textAlign: 'center' }} headerStyle={{ background: "#99FFFF" }} />
                  )}

                  {showFsaColumns && (
                    <Column field="planned_fsa_development_date" header="Planned FSA Development Date
                " body={(e) => showDate(e.planned_fsa_development_date)} style={{ minWidth: '120px', textAlign: 'center' }} headerStyle={{ background: "#99FFFF" }} />
                  )}

                  {showFsaColumns && (
                    <Column field="actual_fsa_development_date" header="Actual FSA Development Date
                " body={(e) => showDate(e.actual_fsa_development_date)} style={{ minWidth: '120px', textAlign: 'center' }} headerStyle={{ background: "#99FFFF" }} />
                  )}

                  {showFsaColumns && (
                    <Column field="actual_development_month_days" header="Actual Development Month/Days
                " body={(e) => showDate(e.actual_development_month_days)} style={{ minWidth: '120px', textAlign: 'center' }} headerStyle={{ background: "#99FFFF" }} />
                  )}

                  {showFsaColumns && (
                    <Column field="development_month_days" header=" Development Month/Days
                " body={(e) => showDate(e.development_month_days)} style={{ minWidth: '120px', textAlign: 'center' }} headerStyle={{ background: "#99FFFF" }} />
                  )}

                  {/* //*--------------------------New Added 14 0602024------------------------------------------------- */}




                  <Column field="ContacttoFSAMonthsAndDays" body={(e) => showDevide(e.ContacttoFSAMonthsAndDays, e.projectType)} style={{ minWidth: '130px', textAlign: 'center', }} header="Contact to FSA Months/Days" headerStyle={{ background: "#CCCCFF" }} />



                  <Column field="fsa_signed_date_em_playbook" header="FSA SIGNED DATE" body={(e) => showDate(e.fsa_signed_date_em_playbook)} style={{ minWidth: '120px', textAlign: 'center' }} headerStyle={{ background: "#CCCCFF" }} />

                  <Column field="forecasted_building_date_em_playbook" header="Planned BUILDING PERMIT DATE" body={(e) => showDate(e.forecasted_building_date_em_playbook)} style={{ minWidth: '180px', textAlign: 'center' }} headerStyle={{ background: "#CCCCFF" }} />

                  <Column field="building_permit_recieved_em_playbook" header="BUILDING PERMIT DATE" body={(e) => showDate(e.building_permit_recieved_em_playbook)} style={{ minWidth: '160px', textAlign: 'center' }} headerStyle={{ background: "#CCCCFF" }} />

                  <Column field="actual_pre_con_month_by_day_em_playbook" header="ACTUAL PRE CON MONTHS/DAYS" body={(e) => showDevide(e.actual_pre_con_month_by_day_em_playbook, e.projectType)} style={{ minWidth: '180px', textAlign: 'center' }} headerStyle={{ background: "#CCCCFF" }} />

                  <Column field="of_pre_con_month_by_day_em_playbook" header="# PRE CON MONTHS/DAYS SLIPPAGES"

                    body={(e) => {
                      const date = showDevide(e.of_pre_con_month_by_day_em_playbook, e.projectType);
                      const isEmpty = !date;
                      const color = isEmpty ? 'black' : getColorForDate(date);

                      return (
                        <div style={{ color, height: '36px', paddingTop: '8px' }}>
                          {date}
                        </div>
                      );
                    }}

                    style={{ minWidth: '180px', textAlign: 'center', }} headerStyle={{ background: "#CCCCFF" }} />
                  {/* //*----------------------------------------------------------------------------------------------- */}


                  <Column field="contractDate" header="Contract Date" body={(e) => showDate(e.contractDate)} style={{ minWidth: '130px', textAlign: 'center', }} headerStyle={{ background: "#D0F0C0" }} />



                  <Column field="FSAtoContractMonthsAndDays" body={(e) => showDevide(e.FSAtoContractMonthsAndDays, e.projectType)} style={{ minWidth: '160px', textAlign: 'center' }} header="FSA to Contract Months/Days" headerStyle={{ background: "#D0F0C0" }} />



                  <Column field="actualStartDate" body={(e) => showDate(e.actualStartDate)} style={{ minWidth: '130px', textAlign: 'center' }} header="Actual Start Date" headerStyle={{ background: "#D0F0C0" }} />

                  {/* //*--------------------------New Added 14 0602024------------------------------------------------- */}
                  <Column field="forecasted_complation_data_pm" body={(e) => showDate(e.forecasted_complation_data_pm)} style={{ minWidth: '130px', textAlign: 'center' }} header="Planned COMPLETION DATE" headerStyle={{ background: "#D0F0C0" }} />
                  {/* //*------------------------------------------------------------------------------------------------ */}


                  <Column field="actualCompletionDate" body={(e) => showDate(e.actualCompletionDate)} style={{ minWidth: '150px', textAlign: 'center' }} header="Actual Completion Date" headerStyle={{ background: "#D0F0C0" }} />

                  <Column field="actual_slippage_of_month_dat_pm" header="ACTUAL # OF MONTHS/DAYS" style={{ minWidth: '130px', textAlign: 'center' }} headerStyle={{ background: "#D0F0C0" }} />

                  <Column field="slippage_of_month_by_day_pm" header="# OF MONTHS/DAYS SLIPPAGES +/-"

                    body={(e) => {
                      const date = showDevide(e.slippage_of_month_by_day_pm, e.projectType);
                      const isEmpty = !date;
                      const color = isEmpty ? 'black' : getColorForDate(date);

                      return (
                        <div style={{ color, height: '36px', paddingTop: '8px' }}>
                          {date}
                        </div>
                      );
                    }}
                    style={{ minWidth: '130px', textAlign: 'center', }} headerStyle={{ background: "#D0F0C0" }} />

                  <Column field="monthLeft" header="Months Left" style={{ minWidth: '130px', textAlign: 'center' }} headerStyle={{ background: "#D0F0C0" }} />

                  <Column field="hoursPerDay" header="Hours Per Day" body={(e) => hoursPerDay(e.projectType, e.hoursPerDay)} style={{ minWidth: '130px', textAlign: 'center' }} headerStyle={{ background: "#D0F0C0" }} />

                  <Column field="3Month" header="3 Months Warranty" body={(e) => checkDateForMonthe(getFutureDate(e.actualCompletionDate, 3), e.month_3_color) || ''} style={{ minWidth: '130px', textAlign: 'center', }} headerStyle={{ background: "#89CFF0" }} />

                  <Column field="6Month" header="6 Months Warranty" body={(e) => checkDateForMonthe(getFutureDate(e.actualCompletionDate, 6), e.month_6_color) || ''} style={{ minWidth: '130px', textAlign: 'center' }} headerStyle={{ background: "#89CFF0" }} />

                  <Column field="12Month" header="12 Months Warranty" body={(e) => checkDateForMonthe(getFutureDate(e.actualCompletionDate, 12), e.month_12_color) || ''} style={{ minWidth: '130px', textAlign: 'center' }} headerStyle={{ background: "#89CFF0" }} />

                  <Column field="pM" header="Project Manager" body={(e) => getPMNameAndIcon(e.pM, e.pMColorCode)} style={{ minWidth: '200px', textAlign: 'center', }} />
                  <Column field="projectType" header="Project Type" style={{ minWidth: '200px', textAlign: 'center', }} />
                  <Column field="status" header="status" style={{ minWidth: '200px', textAlign: 'center', }} />



                </DataTable>
              </div>
            </div>
          )}
          {/* --------------Modal Open--------------- */}
        </div>
        {isModalOpen && <ProductionSetting visible={isModalOpen} closeModel={closeModelAdd} onSuccess={getDashboardData} />}
      </div>
    </>
  )
}

export default DashbordArchived